<template>
  <BasePage title="Confirming email...">
    <div class="fs-2r text-muted text-center mt-2">
      Confirming Email Address...
    </div>
    <Loader class="mt-4"/>
  </BasePage>
</template>

<script>
import BasePage from './BasePage.vue'

import Loader from './Loader.vue'

import store from '../store.js'

export default {
  name: 'ConfirmEmail',
  props: {
    key: {
      type: String,
      required: true,
    },
  },
  components: {
    BasePage,
    Loader,
  },
  mounted () {
    const { key } = this
    store.commit('notify', { message: 'Confirming your email...', level: 'warning' })
    store.dispatch('confirmEmail', { key })
  },
}
</script>

<style lang="scss">

@import '../_variables.scss';

.login-error {
  color: $DANGER;
  transition: all 0.5 ease;
  text-align: center;
  font-style: italic;
}

</style>



// WEBPACK FOOTER //
// ConfirmEmail.vue?505acf00